module.exports = __webpack_public_path__ + "img/UTEAST-7.4e557d12.jpg";